"use client";

import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { Magnetic } from "./motion-primitives";
import type { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "brass" | "ink" | "outline" | "ghostLight";

const styles: Record<Variant, string> = {
  brass:
    "bg-brass text-ink hover:bg-brass-soft shadow-[0_10px_40px_-12px_color-mix(in_oklab,var(--brass)_65%,transparent)]",
  ink: "bg-ink text-softwhite hover:bg-ink/90",
  outline:
    "border border-ink/25 text-ink hover:border-ink hover:bg-ink hover:text-softwhite",
  ghostLight:
    "border border-softwhite/30 text-softwhite hover:bg-softwhite hover:text-ink backdrop-blur-sm",
};

export function Cta({
  children,
  variant = "brass",
  className,
  withArrow = true,
  magnetic = true,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: Variant;
  withArrow?: boolean;
  magnetic?: boolean;
}) {
  const btn = (
    <button
      {...props}
      className={cn(
        "group inline-flex items-center gap-2.5 rounded-full px-6 py-3.5 text-sm font-semibold tracking-tight transition-all duration-300 focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-brass",
        styles[variant],
        className,
      )}
    >
      {children}
      {withArrow && (
        <ArrowRight
          className="size-4 transition-transform duration-300 group-hover:translate-x-1"
          aria-hidden
        />
      )}
    </button>
  );

  return magnetic ? <Magnetic>{btn}</Magnetic> : btn;
}